import { withProps } from 'recompose'

const withClientId = withProps({ clientId: window.location.hostname })

export default withClientId



// WEBPACK FOOTER //
// ./src/App/hocs/withClientId.js